var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageHiBillLevelPayPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m34.96 15.172-1.21.393v-1.272a1.75 1.75 0 0 0-1.75-1.75 1.75 1.75 0 0 0-1.75 1.75v1.272l-1.21-.393a1.75 1.75 0 0 0-2.2 1.124 1.751 1.751 0 0 0 1.119 2.204l1.209.393-.747 1.029a1.75 1.75 0 0 0 .387 2.444 1.749 1.749 0 0 0 2.444-.387L32 20.951l.747 1.029a1.749 1.749 0 0 0 2.444.387 1.75 1.75 0 0 0 .387-2.444l-.748-1.029 1.21-.393a1.75 1.75 0 1 0-1.081-3.329Z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75 21.61v-2.539a23.009 23.009 0 0 0 7.466-4.812 1.75 1.75 0 1 0-2.432-2.518 19.447 19.447 0 0 1-5.034 3.5V15a1.75 1.75 0 0 0-3.5 0v1.548a20.182 20.182 0 0 1-9.574.234 10.762 10.762 0 0 0-5.426-8.154V5.5a5.25 5.25 0 0 0-10.5 0v3.128a10.762 10.762 0 0 0-5.426 8.154 20.182 20.182 0 0 1-9.574-.234V15a1.75 1.75 0 0 0-3.5 0v.243a19.447 19.447 0 0 1-5.034-3.5 1.75 1.75 0 1 0-2.432 2.516 23.009 23.009 0 0 0 7.466 4.812v2.539L.417 38.255A1.744 1.744 0 0 0 .25 39a9.75 9.75 0 0 0 19.5 0 1.744 1.744 0 0 0-.167-.745L11.75 21.61v-1.474a23.63 23.63 0 0 0 5.257.615 23.723 23.723 0 0 0 4.5-.441 10.777 10.777 0 0 0 5.243 7.062V53.25H25A6.758 6.758 0 0 0 18.25 60v2A1.75 1.75 0 0 0 20 63.75h24A1.75 1.75 0 0 0 45.75 62v-2A6.758 6.758 0 0 0 39 53.25h-1.75V27.372a10.777 10.777 0 0 0 5.243-7.062 23.715 23.715 0 0 0 4.5.441 23.643 23.643 0 0 0 5.257-.615v1.474l-7.833 16.645a1.744 1.744 0 0 0-.167.745 9.75 9.75 0 0 0 19.5 0 1.744 1.744 0 0 0-.167-.745ZM10 45.25a6.257 6.257 0 0 1-5.994-4.5h11.988A6.257 6.257 0 0 1 10 45.25Zm5.242-8H4.758L10 26.11ZM30.25 5.5a1.75 1.75 0 0 1 3.5 0v1.905a9.957 9.957 0 0 0-3.5 0ZM39 56.75A3.254 3.254 0 0 1 42.25 60v.25h-20.5V60A3.254 3.254 0 0 1 25 56.75Zm-8.75-3.5V28.6a9.957 9.957 0 0 0 3.5 0v24.65Zm1.75-28A7.25 7.25 0 1 1 39.25 18 7.258 7.258 0 0 1 32 25.25Zm22 .86 5.242 11.14H48.758Zm0 19.14a6.257 6.257 0 0 1-5.994-4.5h11.988A6.257 6.257 0 0 1 54 45.25Z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageHiBillLevelPayPlan);
export default __webpack_public_path__ + "static/media/manageHiBill-level-pay-plan.5aa761e4b3d507958e73de5ea4c9a9cd.svg";
export { ForwardRef as ReactComponent };